/**
 * Created by mestrad on 2018. 09. 25..
 */

export default Memorial;

import Base from "./Base";
import Map from "../../Map";
import TimeLine from "../../TimeLine";
import AutoComplete from "../../AutoComplete";

const $ = jQuery;

function Memorial(config) {
    Base.call(this, config);
    var self = this;
    var searchMap;
    var searchTimeLine;
    var placeholderList;
    var mapFilter = false;
    var timeLineFilter = false;
    var filterCount = 0;
    var categoryList;
    var notAutoCompleteTypeList = ["map", "timeline"];
    var nameSpaceConnectionTypeList = [
        'location_details',
        'related_person',
        'related_person_profession',
        'related_corporate'
    ];

    function render(placeholders) {
        placeholderList = placeholders;
        addSearchMap();
        addSearchTimeLine();
        initEvents();
    }

    function createFilter( type = false, defaultSelected = false, relation = 'and' ) {
        if ( !! $( config.domElements.wrapperSelector ).children().length ) {
            var newFilterId = `#${ self.getSelectId( filterCount, 'Types' ) }`;
            self.addFilter(config.domElements.wrapperSelector, filterCount,
                self.getFilterTypes(categoryList, getExtraFilterTypes()),
                newFilterId );
            var activeOption = self.getFilterTypes(categoryList, getExtraFilterTypes())[0].id;
            var newWrapper = $(newFilterId).parent().find(".filterSelectWrapper");
            refreshFilterWrapper(newWrapper, activeOption);
            initFilterEvents( type, defaultSelected, relation );
            return;
        }
        filterCount = 0;
        var formCode = '<div id="nnpSearchSelectContainer">';
        self.getOptionList('category-types', function (categories) {
            categories = [];
            categoryList = categories;
            var filterTypes = self.getFilterTypes(categories, getExtraFilterTypes());
            formCode += self.createSelect(filterTypes, config.domElements.filterTypesId, config.domElements.filterTypesClass) + '<div class="filterSelectWrapper">';
            placeholderList.$wrapperObj.html(formCode);
            checkSelectedOption();

            if (!timeLineFilter && !mapFilter) {
                var holderInput = self.createAutoCompleteInput(config.domElements.filterOptionsId + "helper");
                formCode += holderInput;
                if (filterTypes[0].id === "identifier") {
                    formCode += self.createInput(config.domElements.filterOptionsId + "_value");
                }
                formCode += self.createRelationSelect(filterCount) + '</div>';
            } else {
                if (mapFilter) {
                    $("#searchMap").trigger("filterOn");
                    formCode += '<div class="nnp_info">A térképen a <span' +
                        ' class="leaflet-draw-draw-rectangle"></span> gombra' +
                        ' kattintva jelölje ki a területet, amelyen belül' +
                        ' szeretne keresni.</div></div>';
                } else {
                    $("#searchMap").trigger("filterOff");
                }
                if (timeLineFilter) {
                    $(config.domElements.searchTimeLineSelector.timeLineContainerSelector).removeClass("nnpHidden");
                    var dateIntervall = self.createDateIntervall(config);
                    formCode += dateIntervall.code + "</div>";
                }
            }
            formCode += self.createAddAndRemoveBtn() + '</div>';
            placeholderList.$wrapperObj.html(formCode);

            if (dateIntervall) {
                dateIntervall.initDatepicker();
                searchTimeLine.refresh();
                setTimeout(function () {
                    searchTimeLine.addFilterCustomTime(new Date("1900-01-01"), Date.now());
                }, 1000);
            }
            if ($.inArray(filterTypes[0].id, notAutoCompleteTypeList) === -1) {
                AutoComplete({
                    holderItem: "#" + config.domElements.filterOptionsId + "helper",
                    ajaxUrl: config.ajaxUrl,
                    objectType: "memorial",
                    locale: config.locale,
                    type: nameSpaceConnectionTypeList.indexOf(filterTypes[0].id) > -1 ? "search" : "category-types",
                    categoryType: filterTypes[0].id
                });
            }
            initFilterEvents( type, defaultSelected, relation );
        });
    }

    function getExtraFilterTypes() {
        var extraFilters = [
            { title: 'Település szerint', id: 'location_details' },
            { title: 'Térképes kijelölés', id: 'map' },
            { title: 'Jelleg szerint', id: 'memorial_nature_type' }
        ];

        if ( memorialClass !== '72257' ) {
            extraFilters.push( {
                title: 'Jelentőség szerint', id: 'memorial_importance_type'
            } );
        }

        if ( memorialClass === '131961' ) {
            extraFilters.push( {
                title: 'Emlékhely típus', id: 'memorial_type'
            } );
        }

        if ( memorialClass === '131962' ) {
            extraFilters.push( {
                title: 'Állapot szerint', id: 'memorial_status_type'
            } );
        }

        if ( memorialClass === '72257' ) {
            extraFilters.push( {
                title: 'Állapot szerint', id: 'memorial_corporate_combo'
            } );
        }

        extraFilters.push( {
            title: 'Kapcsolódó személy', id: 'related_person'
        } );
        return extraFilters;
    }

    function addSearchTimeLine() {
        if (searchTimeLine == undefined) {
            searchTimeLine = new TimeLine({
                locale: config.locale,
                objectType: config.objectType,
                type: "search",
                selectors: {
                    elementId: placeholderList.$searchTimeLine[0].timeLineSelector,
                    zoomInId: placeholderList.$searchTimeLine[0].zoomInSelector,
                    zoomOutId: placeholderList.$searchTimeLine[0].zoomOutSelector,
                    moveLeftId: placeholderList.$searchTimeLine[0].moveLeftSelector,
                    moveRightId: placeholderList.$searchTimeLine[0].moveRightSelector,
                },
                domElements: config.domElements,
            });
            searchTimeLine.refresh();
            $(config.domElements.searchTimeLineSelector.timeLineContainerSelector).addClass("nnpHidden");
        }
    }

    function addSearchMap() {
        if (searchMap == undefined) {
            searchMap = new Map({
                elementId: placeholderList.$searchMap[0].id,
                domElements: config.domElements,
                type: "search",
            });
            searchMap.refresh();
        }
    }

    function initEvents() {
        var menu                          = $( $(
            'body:not(.home) header .elementor-nav-menu--dropdown-none' )
        .slice( -1 )[ 0 ] ).find( '.elementor-nav-menu' );
        var memorialCorporateComboFilters = $(
            'button[data-filter-type="memorial_corporate_combo"]'
        );

        menu.on( 'click', '.menu-item a', function ( e ) {
            if ( [ ...e.target.parentElement.classList ].includes( 'smart-stone' ) ) {
                return true;
            }
            if ( window.matchMedia( '(max-width: 767px)' ).matches ||
                $( '.dataSheetBlockWidget' ).is( ':visible' ) ) {
                return true;
            }
            const href = e.target.attributes.href.value;
            if ( [ ...e.target.parentElement.classList ].includes( 'menu-item-has-children' ) &&
                 ! e.target.nextElementSibling.querySelectorAll( `a[href="${ href }"]` ).length )
            {
                return true;
            }
            e.preventDefault();
            menu.find( 'li' ).removeClass( 'current_page_item' );

            const isSubmenu = [ ...e.target.classList ].includes( 'elementor-sub-item' );
            var target      = isSubmenu ? $( e.target.closest( 'li.menu-item-has-children' )
                                              .querySelector( 'a' ) ) : $( e.target );
            if ( isSubmenu ) {
                e.target.parentElement.classList.add( 'current_page_item' );
            }
            target.parent().addClass( 'current_page_item' );
            memorialClass = [ '131961', '72257', '131962', '132899' ][ target.parent().index() ];

            window.history.replaceState( null, null, target.attr( 'href' ) );
            $( '#customSearchWrapper' ).empty();
            getExtraFilterTypes();

            memorialCorporateComboFilters.toggle( memorialClass === '72257' );

            $.ajax( {
                type: 'POST', dataType: 'JSON', url: myAjax.ajaxUrl, data: {
                    action: 'number_of_entities', memorialClass: memorialClass
                }, success: function ( response ) {
                    $( '#number_of_entities span' ).html( response.data );
                }
            } );
        } );

        memorialCorporateComboFilters.toggle( memorialClass === '72257' );

        config.$baseForm.on("searchResultReceived", function (event, receivedData) {
            var hasData = !! receivedData;

            searchMap.refresh( hasData && !! receivedData.pageData ?
                               receivedData.pageData :
                               receivedData,
                hasData && !! receivedData.disableCluster
            );
        });
        config.$baseForm.on("change", "#nnp_search_date_from, #nnp_search_date_to", function () {
            var dateFromPicker = $(config.domElements.searchDateFrom);
            var dateToPicker = $(config.domElements.searchDateTo);
            $(".nnpSearchDateIntervallContainer").children(".nnp_error_message").remove();
            if (dateFromPicker.datepicker("getDate") < dateToPicker.datepicker("getDate")) {
                searchTimeLine.setFilterCustomTime(
                    dateFromPicker.datepicker("getDate"),
                    dateToPicker.datepicker("getDate")
                );
            } else {
                $(".nnpSearchDateIntervallContainer").append('<div class="nnp_error_message">A kezdő dátum nem lehet nagyobb a vég dátumnál.</div>');
                searchTimeLine.revertFilterDateIntervall();
            }
        });
    }

    function initFilterEvents( type = false, defaultSelected = false, relation = 'and' ) {
        var addBtn = $(".addFilterBtn");
        var removeBtn = $(".removeFilterBtn");
        var filterTypeSelect = $("#" + self.getSelectId(filterCount, "Types"));
        $(filterTypeSelect).focus();
        addBtn.off("click");
        removeBtn.off("click");
        addBtn.on("click", function () {
            var activeOption = self.getFilterTypes(categoryList, getExtraFilterTypes())[0].id;
            var newFilterId = "#" + self.getSelectId(filterCount, "Types");
            self.addFilter(config.domElements.wrapperSelector, filterCount,
                self.getFilterTypes(categoryList, getExtraFilterTypes()),
                newFilterId);
            initFilterEvents();
            var newWrapper = $(newFilterId).parent().find(".filterSelectWrapper");
            refreshFilterWrapper(newWrapper, activeOption);
        });
        removeBtn.on("click", function () {
            self.removeFilter(this);
            checkSelectedOption();
            self.refreshSearchWrapper(self.getFilterTypes(categoryList, getExtraFilterTypes()));
            if (!timeLineFilter) {
                searchTimeLine.removeFilterCustomTime();
                $(config.domElements.searchTimeLineSelector.timeLineContainerSelector).addClass("nnpHidden");
            }
            if (!mapFilter) $("#searchMap").trigger("filterOff");
        });
        filterTypeSelect.on("change", function () {
            refreshAllSelectOptions(filterTypeSelect.val(), "#" + filterTypeSelect.attr("id"), filterTypeSelect.parent());
        });

        if ( type ) {
            var newFilterId = `#${ self.getSelectId( filterCount, 'Types' ) }`;
            $( newFilterId )
                .find( `option[value="${ type }"]` )
                .prop( 'selected', true )
                .parent()
                .trigger( 'change' );
            var newWrapper = $( newFilterId )
                .parent()
                .find( '.filterSelectWrapper' );
            var $select = $( newWrapper )
                .find( `#${ config.domElements.filterOptionsId }${ filterCount ? `_${ filterCount }` : '' }helper` );

            if ( defaultSelected ) {
                defaultSelected.forEach( function ( e ) {
                    if ( $select.find( `option[value="${ e.id }"]` ).length ) {
                        $select.val( e.id ).trigger( 'change' );
                    } else {
                        $select.append( new Option( e.text, e.id, true, true ) )
                            .trigger( 'change' );
                    }
                } )
            }
            var $relation = $( newWrapper )
                .find( `#${ config.domElements.filterRelationId }${ filterCount ? `_${ filterCount }` : '' }` );
            $relation.prop( 'selectedIndex', $relation.find( `[value=${ relation }]` ).index() );
        }
        filterCount++;
    }

    function refreshAllSelectOptions(value, selectId, parent) {
        refreshFilterWrapper(parent.find(".filterSelectWrapper"), value);
        self.refreshSearchWrapper(self.getFilterTypes(categoryList, getExtraFilterTypes()), selectId);
    }

    function refreshFilterWrapper(wrapper, value) {
        checkSelectedOption();
        if (!$.inArray(value, notAutoCompleteTypeList) < 0) {
            appendFilterInput(wrapper, value);
            // appendFilterSelect( wrapper, value );	
        } else {
            if (value == "map") {
                $("#searchMap").trigger("filterOn");
                wrapper.children().remove();
                wrapper.append('<div class="nnp_info">A térképen a <span' +
                    ' class="leaflet-draw-draw-rectangle"></span> vagy a' +
                    ' <span class="leaflet-draw-draw-circle"></span> gombra' +
                    ' kattintva jelölje ki a területet, amelyen belül' +
                    ' szeretne keresni.</div>');
            } else if (value == "timeline") {
                $(config.domElements.searchTimeLineSelector.timeLineContainerSelector).removeClass("nnpHidden");
                wrapper.children().remove();
                var dateIntervall = self.createDateIntervall(config);
                wrapper.append(dateIntervall.code);
                dateIntervall.initDatepicker();
                searchTimeLine.refresh();
                setTimeout(function () {
                    searchTimeLine.addFilterCustomTime(new Date("1900-01-01"), Date.now());
                }, 1000);
            } else {
                appendFilterInput(wrapper, value);
            }
        }
        if (!mapFilter) $("#searchMap").trigger("filterOff");
        if (!timeLineFilter) {
            $(config.domElements.searchTimeLineSelector.timeLineContainerSelector).addClass("nnpHidden");
            searchTimeLine.removeFilterCustomTime();
        }
    }

    // function appendFilterSelect(wrapper, value) {
    //     var filterTypes = self.getFilterTypes(categoryList, getExtraFilterTypes());
    //     filterTypes.forEach(function (item) {
    //         if (item.id == value) {
    //             var selectId = wrapper.children().attr("id") || self.getSelectId(filterCount - 1, "Options");
    //             wrapper.children().remove();
    //             wrapper.append(self.createSelect(self.getCategoryItems(value, categoryList), selectId, config.domElements.filterOptionsClass) +
    //                 self.createRelationSelect(filterCount - 1));
    //         }
    //     });
    // }

    function appendFilterInput(wrapper, value) {
        var helperArray = wrapper.prev().attr("id").split('_');
        var filterIndex = helperArray.length === 1 ? 0 : helperArray[helperArray.length - 1];
        var filterTypes = self.getFilterTypes(categoryList, getExtraFilterTypes());
        filterTypes.forEach(function ({id}) {
            if (id === value) {

                var selectId = self.getSelectId(filterIndex, "Options");
                var holderInput = self.createAutoCompleteInput(selectId + "helper");
                var plusInput = id === "identifier" ? self.createInput(selectId + "_value") : "";
                wrapper.children().remove();
                wrapper.append(holderInput + plusInput +
                    self.createRelationSelect(filterIndex));

                const type = nameSpaceConnectionTypeList.includes(id) ? 'search' : 'category-types';

                AutoComplete({
                    holderItem: "#" + selectId + "helper",
                    ajaxUrl: config.ajaxUrl,
                    objectType: 'memorial',
                    locale: config.locale,
                    type: type,
                    categoryType: id
                });
            }
        });
    }

    function checkSelectedOption() {
        mapFilter = false;
        timeLineFilter = false;
        $("#customSearchWrapper select").each(function () {
            var item = $("#" + this.id);
            if (item.hasClass(config.domElements.filterTypesClass)) {
                if (item.val() == "map") {
                    mapFilter = true;
                }
                if (item.val() == "timeline") {
                    timeLineFilter = true;
                }
            }
        });
    }

    return {
        render: render,
        createFilter: createFilter
    };
}

Memorial.prototype = Object.create(Base.prototype);